import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, catchError, throwError } from 'rxjs';

import { AdapterService } from './adapter.service';

@Injectable()
export class AdminService {
  private api: string = 'admin';

  constructor(
    private router: Router,
    private adapter: AdapterService,
  ) { }

  public getIam(): Observable<string> {
    return this.adapter.getData(`${this.api}/iam`);
  }

  public verifyEmail(data: object): Observable<any> {
    return this.adapter.postData(`${this.api}/verify-email`, data).pipe(catchError(err => throwError(() => err)));
  }
}